import React from 'react'
import PropTypes from 'prop-types'
import { Element as ScrollElement } from 'react-scroll'

import { H2 } from 'components/Text'
import slugify from 'utils/slugify'

import WhiteLabelMenuCard from '../WhiteLabelMenuCard'
import { MenuListContainer, CategorySection, MenuCards } from './styled'

const MenuList = ({ menus, openModal, ...props }) => (
  <MenuListContainer {...props}>
    {menus.map((category, index) => (
      <CategorySection
        as={ScrollElement}
        key={index}
        name={slugify(category.name)}
      >
        <H2 bold>{category.name}</H2>
        <MenuCards>
          {category.items.map(menu => (
            <WhiteLabelMenuCard
              key={menu.id}
              menu={menu}
              openModal={openModal}
            />
          ))}
        </MenuCards>
      </CategorySection>
    ))}
  </MenuListContainer>
)

MenuList.propTypes = {
  openModal: PropTypes.func.isRequired,
  menus: PropTypes.array,
}

export default MenuList
